export default __webpack_public_path__ + "eb5c6f8f5e6d59e72688e0c4aa0cea2a.png";